<script lang="ts">
  import { setContext } from "svelte";
  import {
    portal,
    escape,
    scrollLock,
    type PlaceAlignModes,
    clickOutside,
    returnFocus,
  } from "@lernetz/svelte-common/actions";
  import { createOverlay, type Overlay } from "./overlay";
  import { DropdownContext, createDropdownMenu, type Menu } from "./dropdown-menu";
  import DropDownPanel from "./dropdown/InnerDropDown.svelte";

  export let align: PlaceAlignModes = "Top";

  const overlay = createOverlay();
  const menu = createDropdownMenu(overlay);

  setContext<{ menu: Menu; overlay: Overlay }>(DropdownContext, {
    menu,
    overlay,
  });
</script>

<slot {overlay} {menu} />
{#if $overlay.opened}
  <div
    use:portal
    use:escape={overlay.close}
    use:scrollLock
    use:returnFocus
    use:clickOutside={{ handler: overlay.close }}
  >
    <DropDownPanel {overlay} {align} {menu}>
      <slot name="content" {overlay} {menu} />
    </DropDownPanel>
  </div>
{/if}
